import { Box, Typography } from "@mui/material";

import StyledButton from "./StyledButton";

function TicketBox({ ticket, onClick, purchaseLabel }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <Typography
        variant="h4"
        sx={(theme) => ({
          mt: 1,
          ...theme.components.ticketBox.text.name,
        })}
      >
        {ticket.name}
      </Typography>

      {ticket.description && (
        <Typography
          variant="h4"
          sx={(theme) => ({
            mt: "10px",
            ...theme.components.ticketBox.text.description,
          })}
        >
          {ticket.description}
        </Typography>
      )}

      <Typography
        variant="h4"
        sx={(theme) => ({
          mt: 2,
          ...theme.components.ticketBox.text.price,
        })}
      >
        {ticket.display_price}
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <StyledButton
          aria-label={purchaseLabel}
          variant="contained"
          sx={{
            width: "34%",
            fontSize: "20px",
            fontWeight: "bold",
            mt: 2,
            mb: 1,
          }}
          onClick={() => onClick(ticket.ticket_key)}
        >
          BUY
        </StyledButton>

        {ticket.notice && (
          <Typography
            variant="h4"
            sx={(theme) => ({
              ...theme.components.ticketBox.text.notice,
            })}
          >
            {ticket.notice}
          </Typography>
        )}
      </Box>
    </Box>
  );
}

export default TicketBox;
